<button>
  <fa-icon [icon]="getIconForSide()" class="text-secondary text-3xl cursor-pointer drop-shadow-lg"></fa-icon>
</button>
